export default {
  esg_dashboard: {
    title: 'Dashboard',
  },
  improvement_plans: {
    title: 'Plan zur Verbesserung',
  },
  question_group_section: {
    card_title: 'Unbeantwortete Umfragen',
    list_header_buyer_company_name: 'Käufer',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'Deadline',
    list_header_status: 'Status',
    number_of_answered_label: 'Beantwortete Fragen',
    // number_of_answered_unit: '',
    number_of_answered: 'In Bearbeitung： {answered}/{total}',
    status_re_answer_request: 'Antrag auf Rücknahme in Bearbeitung',
    answer: 'Antwort',
    withdrawn: 'Zurückgezogen',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'Käufer',
    list_header_question: 'Umfrage',
    list_header_create_at: 'Datum der Ausgabe',
    list_header_deadline: 'Datum des Verfalls',
    list_header_status: 'Status',
    limit_one_year: 'Ein Jahr ab Ausstellungsdatum',
    esg_score: 'ESG-Punktzahl',
    esg_rating: 'ESG-Bewertung',
    detail: 'Detail',
  },
  faq_section: {
    card_title: 'FAQs',
    faq_why_request: {
      question:
        'Warum habe ich über ASUENE ESG eine Umfrage von einem Geschäftspartner erhalten?',
      answer:
        'In den letzten Jahren hat sich die nachhaltige Beschaffung zu einem bedeutenden Trend entwickelt, und die Unternehmen sind verpflichtet, in ihrer gesamten Lieferkette ESG-bezogene Themen zu berücksichtigen.Die Unternehmen müssen nicht nur ihre eigenen ESG-Aktivitäten überprüfen und offenlegen, sondern auch ihre Geschäftspartner überprüfen und dazu ermutigen, Maßnahmen im Zusammenhang mit ESG-Aktivitäten zu ergreifen.',
    },
    faq_what_benefit: {
      question: 'Was sind die Vorteile der Beantwortung von ASUENE ESG?',
      answer:
        'Die Beantwortung einer Umfrage über ASUENE ESG hat drei Vorteile.\n1) Sie verstehen die Stärken und Schwächen Ihres Unternehmens in Bezug auf ESG\n2) Sie vergleichen die Bewertung Ihres Unternehmens mit anderen Unternehmen in Ihrer Branche\n3) Sie werben für die ESG-Aktivitäten Ihres Unternehmens, indem Sie die Ergebnisse Ihrer Bewertung offenlegen.',
    },
    list: 'Liste anzeigen',
  },
  contact_section: {
    card_title: 'Kontaktieren Sie uns',
    description:
      'Wenn Sie Fragen zur Umfrage haben oder wissen möchten, wie Sie antworten sollen, können Sie uns jederzeit kontaktieren.\nWenn Sie spezifischere Unterstützung bei der Verbesserung Ihrer ESG-Aktivitäten wünschen, können Sie unseren Berater um Hilfe bitten.',
    inquiry: 'Kontaktieren Sie uns',
  },
}
